/**
 * ACCORDION STANDALONE MODULE
 */

export namespace Accordion {
	/**
	 * Function intializes all Accordion Modules
	 * @constructor
	 */
	let SetupAccordions = () => {
        let accordionTriggers = document.querySelectorAll<HTMLElement>('.js-acc-trigger');
        accordionTriggers.forEach((trigger) => {
           trigger.addEventListener('click', (event) => {
              let parent = trigger.parentElement;

              if(parent.classList.contains("state-open")) {
                  parent.classList.remove("state-open");
              } else {
                  parent.classList.add('state-open');
              }

              event.preventDefault();
           });
        });
    }

	/**
	 * Function to setup Structured Content - Structured Content helps google know what type of content it is looking for - in this case FAQ type
	 * @constructor
	 */
	let SetupStructuredContent = () => {
		let items = document.querySelectorAll('.accordion-list--faq .accordion-list__item');

		if(document.querySelector('.accordion-list--faq')) {
			let el = document.createElement('script');
			el.type = 'application/ld+json';
			let jsonString;
			let questions = [];


			items.forEach((item) => {
				let qstn = item.querySelector('.js-acc-trigger');
				let qstnCon:any = qstn.textContent;
				let content = item.querySelector('.accordion-list__content-inner');
				let contentCon:any = content.innerHTML;
				let theQuestion = {
					"@type": "Question",
					"name": qstnCon.replace(/(\r\t\n|\n|\r|\t)/gm, ""),
					"acceptedAnswer": {
						"@type": "Answer",
						"text": contentCon.replace(/(\r\t\n|\n|\r|\t)/gm, "")
					}
				}
				questions.push(theQuestion);
			});

			jsonString = {
				"@context": "https://schema.org",
				"@type": "FAQPage",
				"mainEntity": questions
			}

			el.text = JSON.stringify(jsonString);

			document.querySelector('head').appendChild(el);
		}
	}


	/**
	 * Initialize our Accordion Module
	 */
	export const init = () => {		
		SetupAccordions();
		SetupStructuredContent();
	}
}

/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', Accordion.init);
} else {  // `DOMContentLoaded` has already fired
	Accordion.init();
}
